import React from "react";
import { Tips } from "@signolteam/shared/context-level-tips";
import { SectionContainer } from "@src/pages/sharedSections";
import { useDCContext } from "@src/context/dcContext";
import { ImageWithRetry } from "@src/components/atoms";
import { useOperatorContext } from "@src/context/operatorContext";

const TipsCard = (props) => {
  const { behaviourAcronym, currentVehicle } = props;
  const dc = useDCContext();
  const { profile } = useOperatorContext();
  const { customer } = profile;

  const { getDynamicReplacement, existsDynamicReplacements } = dc;

  let selectedTips = [];

  const tipsRequest = {
    industry: customer?.industry,
    behaviour: behaviourAcronym,
    customer: customer?.customerCode,
    vehicle: currentVehicle?.id,
  };
  const contextLevelTips = new Tips();
  const selectedTip = contextLevelTips.computeOne(tipsRequest);
  if (selectedTip?.tip) {
    selectedTips.push(selectedTip);
  }

  let logoURL = getDynamicReplacement(
    "captain__behaviours__tips__tipslogo",
    {},
  );
  if (
    existsDynamicReplacements(
      `captain__behaviours__tips__${customer?.customerCode?.toLowerCase()}_logo__tipslogo`,
    )
  ) {
    logoURL = getDynamicReplacement(
      `captain__behaviours__tips__${customer?.customerCode?.toLowerCase()}_logo__tipslogo`,
      {},
    );
  }

  return (
    <div>
      {selectedTips.length > 0 && (
        <div className="py-4">
          <SectionContainer padding={false} shadow={false}>
            <div className="flex justify-center align-center pt-4">
              <ImageWithRetry
                className="h-20 w-auto"
                src={logoURL}
                alt="Signol logo"
              />
            </div>
            <div className="flex flex-col md:flex-row p-6">
              <div className="w-full h-full my-4 md:mx-4">
                <div className="bg-yellow-100 rounded-xl p-4 text-primary-800">
                  {selectedTips[0]?.tip}
                </div>
              </div>
            </div>
          </SectionContainer>
        </div>
      )}
    </div>
  );
};

TipsCard.propTypes = {};

export default TipsCard;
